import Link from "next/link";
import { cn } from "@/lib/utils";

interface Direct {
  href: string;
  text: string;
  icon?: React.ReactNode;
}

interface SectionHeadingProps {
  title: string;
  description?: string;
  direct?: Direct;
  className?: string;
}

export function SectionHeading({
  title,
  description,
  direct,
  className,
}: SectionHeadingProps) {
  return (
    <div className={cn("flex items-center justify-between", className)}>
      <div>
        <h2 className="mb-2 text-3xl font-bold dark:text-[#00ff99]">{title}</h2>
        {description && (
          <p className="text-secondary-foreground/80 dark:text-purple-200 pb-2 font-semibold text-base lg:text-lg">
            {description}
          </p>
        )}
      </div>
      {direct && (
        <Link
          href={direct.href}
          className="flex items-center gap-2 hover:no-underline"
        >
          <span
            className={cn(
              "underline-none hidden text-secondary-foreground hover:border-b hover:text-blue-700 dark:hover:text-accent-green md:inline"
            )}
          >
            {direct.text}
          </span>
          {direct.icon}
        </Link>
      )}
    </div>
  );
}
